/**
 * Ana sayfa tercihleri — hesabı izleyen üç görünürlük/sıra kararı (V5-15).
 *
 * Oynatıcı tercihleri (ses, hız, altyazı, görüntü) cihazda kalır; buradakiler
 * sunucuda kullanıcıya bağlıdır. Bozuk veya eski bir yanıt ana sayfayı
 * kilitlemesin diye her alan tek tek güvenli varsayılana düşer.
 */
import type { HomePreferences } from './api.ts';

export const DEFAULT_HOME_PREFERENCES: HomePreferences = {
  showContinue: true,
  showRecent: true,
  showCollections: true,
  showHistory: true,
  watchlistFirst: false,
};

export function normalizeHomePreferences(value: unknown): HomePreferences {
  if (typeof value !== 'object' || value === null) return { ...DEFAULT_HOME_PREFERENCES };
  const input = value as Record<string, unknown>;
  return {
    showContinue:
      typeof input.showContinue === 'boolean'
        ? input.showContinue
        : DEFAULT_HOME_PREFERENCES.showContinue,
    showRecent:
      typeof input.showRecent === 'boolean'
        ? input.showRecent
        : DEFAULT_HOME_PREFERENCES.showRecent,
    showCollections:
      typeof input.showCollections === 'boolean'
        ? input.showCollections
        : DEFAULT_HOME_PREFERENCES.showCollections,
    showHistory:
      typeof input.showHistory === 'boolean'
        ? input.showHistory
        : DEFAULT_HOME_PREFERENCES.showHistory,
    watchlistFirst:
      typeof input.watchlistFirst === 'boolean'
        ? input.watchlistFirst
        : DEFAULT_HOME_PREFERENCES.watchlistFirst,
  };
}

export function isDefaultHomePreferences(value: HomePreferences): boolean {
  return (
    value.showContinue === DEFAULT_HOME_PREFERENCES.showContinue &&
    value.showRecent === DEFAULT_HOME_PREFERENCES.showRecent &&
    value.showCollections === DEFAULT_HOME_PREFERENCES.showCollections &&
    value.showHistory === DEFAULT_HOME_PREFERENCES.showHistory &&
    value.watchlistFirst === DEFAULT_HOME_PREFERENCES.watchlistFirst
  );
}
